<template>
  <div class="home">
    <b-container fluid>
      <GlobalAnalyticsPage class="marginal" ></GlobalAnalyticsPage>
    </b-container>
  </div>
</template>

<script>
import AnalyticsPage from '@/components/AnalyticsPage.vue';
import GlobalAnalyticsPage from '@/components/GlobalAnalyticsPage.vue';
export default {
  name: 'Analytics',
  components: {
    AnalyticsPage,
    GlobalAnalyticsPage
  }
}
</script>